export default "__VITE_ASSET__862240b7__"